import axios from 'axios';

const baseURL = import.meta.env.VITE_API_URL;

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

// O cookie HttpOnly 'red1000Jwt' será enviado automaticamente pelo navegador
// quando withCredentials: true estiver configurado
// IMPORTANTE: Cookies HttpOnly NÃO aparecem no header 'cookie' visível no DevTools
// mas são enviados automaticamente pelo navegador para o backend
// O backend deve ler o token diretamente do cookie (não do header Authorization)

api.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error instanceof Error ? error : new Error(String(error)))
);

api.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error instanceof Error ? error : new Error(String(error)))
);
